// Athlete API — talks ONLY to the two edge functions, never the database.
// Plain fetch (no @supabase/* dep) to keep the bundle minimal. The publishable key is
// sent as the apikey header so the functions gateway accepts the request.
const BASE = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1`;
const APIKEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

export interface ProtocolItem {
  id: string;
  orderIndex: number;
  exerciseName: string;
  description: string | null;
  cues: string | null;
  sets: number | null;
  reps: number | null;
  holdSeconds: number | null;
  side: string | null;
}

export interface Protocol {
  title: string | null;
  status: string;
  items: ProtocolItem[];
}

async function call(fn: string, body: unknown): Promise<Response> {
  return fetch(`${BASE}/${fn}`, {
    method: 'POST',
    headers: { 'content-type': 'application/json', apikey: APIKEY },
    body: JSON.stringify(body),
  });
}

export async function getProtocol(token: string): Promise<Protocol> {
  const res = await call('get-protocol-by-token', { token });
  if (!res.ok) throw new Error(res.status === 404 ? 'This link is no longer active.' : 'Could not load your protocol.');
  return res.json();
}

export async function markComplete(token: string, assignmentItemId: string): Promise<void> {
  const res = await call('post-adherence-by-token', {
    token,
    assignmentItemId,
    eventType: 'completed',
    occurredAt: new Date().toISOString(),
  });
  if (!res.ok) throw new Error('Could not save — try again.');
}
